import type { ReactNode } from 'react'
import './OfferCard.css'

export interface OfferCardProps {
  label: string
  title: string
  price: string
  priceUnit?: string
  cta?: ReactNode
  badge?: ReactNode
  featured?: boolean
  children: ReactNode
}

export function OfferCard({ label, title, price, priceUnit, cta, badge, featured = false, children }: OfferCardProps) {
  return (
    <div className={`azoya-offer-card${featured ? ' azoya-offer-card--featured' : ''}`}>
      {badge && <div className="azoya-offer-card-badge">{badge}</div>}
      <div className="azoya-offer-card-label">{label}</div>
      <div className="azoya-offer-card-title">{title}</div>
      <div className="azoya-offer-card-price-row">
        <span className="azoya-offer-card-price">{price}</span>
        {priceUnit && <span className="azoya-offer-card-price-unit">{priceUnit}</span>}
      </div>
      <div className="azoya-offer-card-divider" />
      <div className="azoya-offer-card-children">{children}</div>
      {cta && <div className="azoya-offer-card-cta">{cta}</div>}
    </div>
  )
}
